import AlertsEventsDataViewer from './AlertsEventsDataViewer'
import AlertsQueryHandler from './AlertsQueryHandler'
import AlertsSupportDataViewer from './AlertsSupportDataViewer'

export default {
  install( molten ) {
    molten.addPlugin( 'DataViewer', AlertsSupportDataViewer )
    molten.addPlugin( 'DataViewer', AlertsEventsDataViewer )
    molten.addPlugin( 'EventQueryOptionsHandler', AlertsQueryHandler )
  }
}
